/**
 * Shared art for the site location pin, drawn both as a React component over a
 * static map and as an icon URL for a Google Maps marker.
 *
 * The colours mirror the ambrosia `purple-600` and `gray-500` tokens. An SVG
 * served as a data URI is its own document, so it cannot read the CSS custom
 * properties those tokens are defined as, and the values have to be repeated
 * here as literals. Keep them in step with `packages/ambrosia/src/tailwind.config.css`.
 */
export const SITE_PIN_COLOUR = '#6639c9';
export const LOOKUP_PIN_COLOUR = '#747377';

export const SITE_PIN_VIEW_BOX = '0 0 34 44';
export const SITE_PIN_PATH =
  'M17 43C17 43 32 26.4 32 17A15 15 0 1 0 2 17c0 9.4 15 26 15 26Z';
export const SITE_PIN_SHADOW = 'drop-shadow(0 3px 4px rgba(0,0,0,0.45))';

export const SITE_PIN_ICON_SIZE = { width: 30, height: 40 };
export const SITE_PIN_ICON_ANCHOR = { x: 15, y: 39 };

/**
 * A pin as a data URI, for APIs that take an icon URL rather than a node.
 * `active` gives the filled, shadowed treatment used for the draggable pin.
 */
export const getSitePinDataUri = ({
  colour,
  fill = colour,
  active = false,
}: {
  colour: string;
  fill?: string;
  active?: boolean;
}) =>
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="${SITE_PIN_ICON_SIZE.width}" height="${SITE_PIN_ICON_SIZE.height}" viewBox="${SITE_PIN_VIEW_BOX}"${active ? ` style="filter: ${SITE_PIN_SHADOW}"` : ''}>
      <path d="${SITE_PIN_PATH}" fill="${fill}" stroke="${active ? 'white' : colour}" stroke-width="2.5"/>
      <circle cx="17" cy="17" r="${active ? 5.5 : 5}" fill="${active ? 'white' : colour}"${active ? '' : ' stroke="white" stroke-width="2"'}/>
    </svg>
  `)}`;
